import { render, staticRenderFns } from "./RewardIcon.vue?vue&type=template&id=2d7baa31"
import script from "./RewardIcon.vue?vue&type=script&lang=js"
export * from "./RewardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports